import { DEFAULT_RADIUS_KM } from '@/constants'

import { isExpandedCoordinatesSearch } from './isExpandedCoordinatesSearch'

type BuildExpandedDestinationLabelArgs = {
  regionName?: string
  useExpandedCoordinates?: boolean | string
  ne?: string
  sw?: string
  variationKey?: string
}

const VARIANT_B_RADIUS_KM = 20

const resolveExpandedRadiusKm = (variationKey?: string): number =>
  variationKey === 'variant_b' ? VARIANT_B_RADIUS_KM : DEFAULT_RADIUS_KM

/**
 * AS-2729: on the expanded-polygon page the destination reads
 * "<regionName> + Nkm". Once the user switches to the map and moves it, the
 * search becomes a map-area search (identified by an ne/sw bounding box) and the
 * region label becomes "Map area" — at which point the radius suffix is
 * misleading, so we drop it and fall back to the plain region label.
 */
export const buildExpandedDestinationLabel = ({
  regionName,
  useExpandedCoordinates,
  ne,
  sw,
  variationKey,
}: BuildExpandedDestinationLabelArgs): string | undefined => {
  const isMapAreaSearch = Boolean(ne && sw)
  const radiusKm = resolveExpandedRadiusKm(variationKey)

  return isExpandedCoordinatesSearch(useExpandedCoordinates) &&
    regionName &&
    !isMapAreaSearch
    ? `${regionName} + ${radiusKm}km`
    : regionName
}
